export default __webpack_public_path__ + "static/media/icon-Piggy-Bank.e9099000.svg";